import 'broadcastchannel-polyfill';

const channel = new BroadcastChannel('onboarding-sync');

export const broadcastOnboardingUpdate = (data: any) => {
  channel.postMessage({
    type: 'ONBOARDING_UPDATE',
    data
  });
};

export const subscribeToBroadcast = (callback: (data: any) => void) => {
  const handleMessage = (event: MessageEvent) => {
    if (event.data.type === 'ONBOARDING_UPDATE') {
      callback(event.data.data);
    }
  };

  channel.addEventListener('message', handleMessage);

  return () => {
    channel.removeEventListener('message', handleMessage);
  };
};